// src/main.ts — Entry point Fase 1
import './styles/reset.css';
import './styles/variables.css';
import './styles/layout.css';
import './styles/components.css';
import './styles/game.css';

import { createGameShell } from './components/GameShell.js';

const app = document.getElementById('app');
if (!app) throw new Error('[Aetheria] #app no encontrado');

createGameShell(app);

// Exponer versión en consola para diagnóstico (sin secretos)
import { GAME_CONFIG } from './data/gameConfig.js';
console.info(
  `%c✦ AETHERIA %c${GAME_CONFIG.version} — Fase 1 · Base profesional`,
  'color:#7cf0ff;font-weight:800',
  'color:#9aa3c7'
);
